import Vue from 'vue'
import VueI18n, { LocaleMessages } from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages (): LocaleMessages {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages: LocaleMessages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const numberFormats = {
  'en': {
    currency: {
      style: 'currency', currency: 'EUR'
    }
  },
  'it': {
    currency: {
      style: 'currency', currency: 'EUR'
    }
  },
  'cn': {
    currency: {
      style: 'currency', currency: 'EUR'
    }
  }
}

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'it',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'it',
  messages: loadLocaleMessages(),
  numberFormats
})

export function getformattedLocale () {
  switch (i18n.locale) {
    case "en": return 'en'
    case "cn": return 'zh-cn'
    default: return 'it'
  }
}

export default i18n
